import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { Chart, Tooltip, TooltipItem } from "chart.js";
import { barChartOptions, doughnutChartOptions, scatterChartOptions } from "~/misc/charts";

export default class extends Controller {
  connect() {
    //Chart.defaults.global.elements.line.borderWidth = 1.5;

    const hours_vs_age = $('#toJs').data('hoursvsage');
    const ctx = $('#hoursVsAge')[0] as HTMLCanvasElement;
    const options = Object.assign({}, scatterChartOptions);
    options.scales = {
      x: { title: { text: hours_vs_age.xlabel, display: true } },
      y: { title: { text: hours_vs_age.ylabel, display: true } }
    };
    options.onClick = function (e, d) {
      if (d.length > 0) {
        const url = (scatter.data.datasets[d[0].datasetIndex].data[d[0].index]! as any).url;
        window.open(url, '_blank');
      }
    };
    const scatter = new Chart(ctx, {
      type: 'scatter',
      data: {
        datasets: hours_vs_age.data,
      },
      options: options
    });

    const doughnut_data = $('#toJs').data('doughnut');
    const ctx2 = $('#doughnut')[0] as HTMLCanvasElement;
    const options2 = Object.assign({}, doughnutChartOptions);
    options2.plugins!.tooltip!.callbacks = {
      label(context) {
        const value = context.parsed as number;
        return `${value} fő`;
      },
    };
    //options2.onClick = function (e, d) {
    //  p(d);
    //  if (d.length > 0) {
    //    p(doughnut_data.urls);
    //    const url = doughnut_data.urls[d[0].datasetIndex].data[d[0].index]!;
    //    window.open(url, '_blank');
    //  }
    //};
    const doughnut = new Chart(ctx2, {
      type: 'doughnut',
      data: {
        datasets: doughnut_data.datasets,
        labels: doughnut_data.labels
      },
      options: options2
    });

    ////$("#usersByRelationship").click(function(e) {
    //function donutClickEvent(event, elements) {
    //	if (elements.length > 0) {
    //		id = relationships.ids[elements[0]._index];
    //		if (id)
    //			window.open('/users?utf8=%E2%9C%93&q%5Btg_count_gt%5D=0&q%5Bcontract_relationship_id_eq%5D=' + id, '_blank');
    //		else
    //			window.open('/users?utf8=%E2%9C%93&q%5Btg_count_gt%5D=0&q%5Bcontract_relationship_id_null%5D=1', '_blank');
    //	}
    //}

    const agetreeyear_data = $('#toJs').data('agetreeyear');
    const ctx3 = $('#ageTreeYear')[0] as HTMLCanvasElement;
    const options3 = Object.assign({}, barChartOptions);
    options3.scales = {
      x: { stacked: true, title: { text: agetreeyear_data.xlabel, display: true } },
      y: { stacked: true, title: { text: agetreeyear_data.ylabel, display: true } }
    };
    options3.plugins!.tooltip = {
      callbacks: {
        label(tooltipItem) {
          return `${tooltipItem.dataset.label}: ${tooltipItem.parsed.x} év / ${tooltipItem.parsed.y} fő`;
        }
      }
    };
    const agetreeyear = new Chart(ctx3, {
      type: 'bar',
      data: {
        datasets: agetreeyear_data.data,
        labels: agetreeyear_data.labels
      },
      options: options3
    });
    //agetreeyear.update();

    const agetreehours_data = $('#toJs').data('agetreehours');
    const ctx4 = $('#ageTreeHours')[0] as HTMLCanvasElement;
    const options4 = Object.assign({}, barChartOptions);
    options4.scales = {
      x: { stacked: true, title: { text: agetreehours_data.xlabel, display: true } },
      y: { stacked: true, title: { text: agetreehours_data.ylabel, display: true } }
    };
    options4.plugins!.tooltip = {
      callbacks: {
        label(tooltipItem) {
          return `${tooltipItem.dataset.label}: ${tooltipItem.parsed.x} év / ${tooltipItem.parsed.y} óra`;
        }
      }

    };
    const agetreehours = new Chart(ctx4, {
      type: 'bar',
      data: {
        datasets: agetreehours_data.data,
        labels: agetreehours_data.labels
      },
      options: options4
    });
    //agetreehours.update();

  }
}
